import dayjs from 'dayjs';

import { type IntakeCase, type IntakeCaseSummary } from 'store/api/intakeCaseApi';

export const mapToIntakeCaseSummary = (intakeCase: IntakeCase): IntakeCaseSummary => ({
    intake_case_id: intakeCase.intakeCaseId,
    member_first_name: intakeCase.memberFirstName,
    member_last_name: intakeCase.memberLastName,
    member_id: intakeCase.memberId,
    member_verified: intakeCase.memberVerified,
    member_eligible: intakeCase.memberEligible,
    benefit: intakeCase.benefit,
    product_service_oid: intakeCase.productServiceOid,
    is_brand: intakeCase.isBrand,
    diagnosis_code: intakeCase.diagnosisCode,
    payer_id: intakeCase.payerId,
    segment_id: intakeCase.segmentId,
    create_date: intakeCase.createDate,
    submit_date: intakeCase.submitDate,
    archived_date: intakeCase.archivedDate,
    prescriber_npi: intakeCase.prescriberNpi,
    prescriber_first_name: intakeCase.prescriberFirstName,
    prescriber_last_name: intakeCase.prescriberLastName,
    prescriber_verified: intakeCase.prescriberVerified,
    intake_case_sla_override: intakeCase.intakeCaseSlaOverride,
    intake_case_archive_override: intakeCase.intakeCaseArchiveOverride,
    intake_status: intakeCase.intakeStatus,
    intake_status_details: intakeCase.intakeStatusDetails,
    auth_request_status: intakeCase.authRequestStatus,
    paused_at: intakeCase.pausedAt,
    paused_reason: intakeCase.pausedReason,
    reminder_date: intakeCase.reminderDate,
    submission_timer_basis: intakeCase.submissionTimerBasis,
    intake_case_snooze_status: undefined,
    assigned_username: intakeCase.assignedUsername,
    updated_date: dayjs().toDate().toDateString(),
    non_formulary: intakeCase.nonFormulary,
});
